<div class="under-liquidation-dialog">
  <div class="dialog-header">
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="ri-close-line"></i>
    </button>
  </div>

  <div class="dialog-body">
    <div class="icon-container">
      <i class="ri-error-warning-line"></i>
    </div>

    <h3 class="dialog-title">
      {{ 'FundStatus.UnderLiquidation' | translate }}
    </h3>

    <p class="dialog-message">
      {{ 'FundStatus.UnderLiquidationMessage' | translate }}
    </p>

    <div class="dialog-actions">
      <button type="button" class="primary-btn confirm-btn" (click)="close()">
        {{ 'Shared.OK' | translate }}
      </button>
    </div>
  </div>
</div>
